import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import HomePage from "./pages/HomePage";
import PaymentFailedPage from "./pages/PaymentFailedPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import RegistrationPage from "./pages/RegistrationPage";
import RazorpayPaymentPage from "./pages/RazorpayPaymentPage";
import OptionsPage from "./pages/OptionsPage";
import ExamDetailPage from "./pages/ExamDetailPage";
import ExamDetailPageOption2 from "./pages/ExamDetailPageOption2";
import ExamDetailPageOption3 from "./pages/ExamDetailPageOption3";
import TermsandConditions from "./pages/TermsandConditions";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/register/payment" element={<RazorpayPaymentPage />} />
          <Route path="/register/payment/failed" element={<PaymentFailedPage />} />
          <Route path="/register/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/terms-and-conditions" element={<TermsandConditions />} />
          <Route path="/options" element={<OptionsPage />} />
          <Route path="/exam/:examId" element={<ExamDetailPage />} />
          <Route path="/exam/:examId/option-2" element={<ExamDetailPageOption2 />} />
          <Route path="/exam/:examId/option-3" element={<ExamDetailPageOption3 />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
